// extracted by mini-css-extract-plugin
export default {"container":"MenuItem_container__BcLIO","wrapper":"MenuItem_wrapper__5kTdX"};